module.exports = __webpack_public_path__ + "img/icon-info.26bc8a1f.svg";